import Vapi from 'vuex-rest-api';
import axios from '@/api/axios';

const store = new Vapi({
  axios,
  state: {
    emptyLabelArchive: [],
  },
})
  .get({
    action: 'getEmptyLabelArchive',
    property: 'emptyLabelArchive',
    path: ({ plantCode }) => `/plant/${plantCode}/label-archive?labelStatus=Empty`,
    onSuccess: (s, { data }) => {
      s.emptyLabelArchive = data.items;
    },
  })
  .getStore({
    namespaced: true,
  });

store.getters = {
  ...store.getters,

  isLabelArchiveEmpty: s => id => !!s.emptyLabelArchive.find(l => l.id === id),
  emptyAmount: s => ids => s.emptyLabelArchive.filter(l => ids.includes(l.id)).length,
};

export default store;
